import React, { useState, useEffect } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import ModalAdmin from './ModalAdmin';

DataTable.use(DT);


function DatatableAdmin({ users }) {
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const transformData = (data) => {
    if (!data) return [];

    return data.filter((item) => item.role).map((item) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        };

        return [
          item.name,
          item.email,
          item.role,
          formatDate(item.date),
          'Grouping',
          item.locked ? 'Bloqué' : 'Débloqué',
          item.locked ? 'Débloqué' : 'Bloqué',
          item._id,
          new Date(item.date).getTime(), // Valeur numérique pour le tri  
        ];
    }).sort((a, b) => b[8] - a[8]);// Tri décroissant par date (colonne cachée)
  };

  useEffect(() => {
    if (users) {
        setTableData(transformData(users));
    }
  }, [users]);

  const columns = [
    { title: 'Nom complet', data: 0 },
    { title: 'Mail', data: 1 },
    { title: 'Role', data: 2 },
    { title: 'Créé le', data: 3 },
    { title: 'Créé par', data: 4 },
    {
      title: 'Statut',
      data: 5,
      render: (statut) => {
        switch (statut) {
          case 'Déconnecté':
            return '<span class="text-warning">Déconnecté</span>';
          case 'Débloqué':
            return '<span class="text-success">Actif</span>';
          case 'Bloqué':
            return '<span class="text-danger">Bloqué</span>';
          default:
            return statut;
        }
      },
    },
    {
      title: 'Action',
      data: 6,
      render: (data) => {
        switch (data) {
          case 'Débloqué':
            return '<button class="btn btn-success btn-sm confirm_lock_user" type="button" data-bs-toggle="modal" data-bs-target="#confirmModal">Débloqué</button>';
          case 'Bloqué':
            return '<button class="btn btn-danger btn-sm confirm_lock_user" type="button" data-bs-toggle="modal" data-bs-target="#confirmModal">Bloqué</button>';
          default:
            return data;
        }
      },
    },
  ];

  // Exemple d’options en français
  const options = {
    order: [[8, 'desc']], // Trie par défaut sur la colonne "Créé le" (index 4)
    language: {
      processing:     'Traitement en cours...',
      search:         'Rechercher&nbsp;:',
      lengthMenu:     'Afficher _MENU_ &eacute;l&eacute;ments',
      info:           'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
      infoEmpty:      'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ments',
      infoFiltered:   '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
      infoPostFix:    '',
      loadingRecords: 'Chargement en cours...',
      zeroRecords:    'Aucun &eacute;l&eacute;ment &agrave; afficher',
      emptyTable:     'Aucune donn&eacute;e disponible dans le tableau',
      paginate: {
        first:      'Premier',
        previous:   'Pr&eacute;c&eacute;dent',
        next:       'Suivant',
        last:       'Dernier',
      },
      aria: {
        sortAscending:  ': activer pour trier la colonne dans l\'ordre croissant',
        sortDescending: ': activer pour trier la colonne dans l\'ordre d&eacute;croissant',
      },
    },
    // Exemple : on utilise `createdRow` pour récupérer l'événement de clic
    // (si vous en avez besoin)
    createdRow: (rowNode, rowData) => {
      const button = rowNode.querySelector('.confirm_lock_user');
      if (button) {
        button.addEventListener('click', () => {
          setSelectedRow(rowData);
        });
      }
    }, /* */
  };
  return (
    <>
      <DataTable
        data={tableData}
        columns={columns}
        options={options}
        className="table table-striped"
        style={{ width: '100%' }}
      />
      {/* Le modal (si vous l'utilisez) */}
      <ModalAdmin selectedRow={selectedRow} />
    </>
  )
}

export default DatatableAdmin